export default __webpack_public_path__ + "static/media/home.23c77f89.svg";